namespace RioERP.Products {
    export interface ProductBillingItemsForm {
        ProductId: Serenity.LookupEditor;
        BillingItemName: Serenity.StringEditor;
        GrossAmount: Serenity.DecimalEditor;
        EDiscountType: Serenity.EnumEditor;
        TaxCategoryId: Serenity.LookupEditor;
        HsnMasterId: Serenity.LookupEditor;
        IncludingTax: Serenity.BooleanEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        SpecialGrossAmount: Serenity.DecimalEditor;
    }

    export class ProductBillingItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Products.ProductBillingItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductBillingItemsForm.init)  {
                ProductBillingItemsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.EnumEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(ProductBillingItemsForm, [
                    'ProductId', w0,
                    'BillingItemName', w1,
                    'GrossAmount', w2,
                    'EDiscountType', w3,
                    'TaxCategoryId', w0,
                    'HsnMasterId', w0,
                    'IncludingTax', w4,
                    'InvoiceCompanyId', w0,
                    'SpecialGrossAmount', w2
                ]);
            }
        }
    }
}
